"use strict";

import 'babel-polyfill';

import _ from 'lodash';
import React from 'react';
import moment from 'moment';

import { connect } from 'react-redux';

import IBE from '../ibe/ibe.js';
import { widgetClasses } from '../ibe/ibe.js';

import { LocalString } from 'translate-react';
import translator from 'translate-react';

import getQueryParameters from 'queryparams';

import { textPeriod } from '../ibe/components/CalendarDisplay';
import { getPeopleString } from '../ibe/components/PeopleDisplay';
import { PeopleSelect } from '../ibe/components/PeopleSelect';
import {
    changePeople,
    setLanguage,
    setSelection,
} from '../ibe/actions.js';

import ReduxMiniCalendar from './ReduxMiniCalendar.js';

require("./style/calendar-exh.less");
require("../ibe/style/peopleselect.less");

if ( window.console && console.log ) { console.log("Explorer IBE initializing"); }

let ReduxPeopleSelect = function(props, context) {
    let { people } = props;
    let { onChange, onClose } = props;

    console.log("ReduxPeopleSelect", props);

    return (
        <PeopleSelect {...props} state={people} onChange={onChange} />
    );
};

ReduxPeopleSelect = connect(
    state => ({ people: state.people }), 
    dispatch => ({
        onChange: (name, value) => dispatch(changePeople(name, value)),
        onClose: _ => dispatch({type: "CLOSE_PEOPLE"}),
    })
)(ReduxPeopleSelect);



export default function CalendarDisplay(props) {
    let { format } = props;
    let { selectionStart, selectionStartHover, selectionEnd, selectionEndHover, nights, selecting } = props.calendar;

    let start = "", end = "";

    if ( selectionStart || selectionStartHover ) {
        start = moment(selectionStart || selectionStartHover).format("DD.MM.YYYY");
    }
    if ( selectionEnd || selectionEndHover ) {
        end = moment(selectionEnd || selectionEndHover).format("DD.MM.YYYY");
    } else {
        end = moment(selectionStart || selectionStartHover).add(1, 'day').format("DD.MM.YYYY");
    }

   return (
        <span className={"datedisplay " + (selecting ? "selecting" : "")}>
            <span className="datedisplay-start">{start}</span>
            <span className="datedisplay-arrow"><i className="icons8-right"></i></span>
            <span className="datedisplay-end">{end}</span>
            <span className="datedisplay-triangle"></span>
        </span>
    );
}

CalendarDisplay = connect(state => ({
    calendar: state.calendar,    
}))(CalendarDisplay);



let appReducer = (state={calendarCount:2}, action) => {
    switch ( action.type ) {
        case 'CLICK_DAY':
            if ( state.selecting ) {
                state = { ...state, selecting: false };

                $('.calender-item').removeClass('pulldown-open');
            } else {
                state = { ...state, selecting: true };
            }
            break;

        case 'CLOSE_CALENDAR':
            //$('#calendar').slideUp();
            break;

        case 'CLOSE_PEOPLE':
            //$('#peopleselect').slideUp();
            break;

        case 'CALENDAR_SET_COUNT':
            state = { ...state, calendarCount: action.count };
            break;
    }
    return state;
};


window.ibe = new IBE({
    appReducer: appReducer,
    language: window.Tramino.lang,
});


/**
 * Reset all time fields of a Date object to zero (hour, minute, second, msec)
 */
var resetTimeFields = function(date) {
    if ( moment.isMoment(date) ) {
        date.hours(0);
        date.minutes(0);
        date.seconds(0);
        date.milliseconds(0);
    } else {
        date.setHours(0);
        date.setMinutes(0);
        date.setSeconds(0);
        date.setMilliseconds(0);
    }
    return date;
};

/**
 * Ein Datum parsen und ein moment-Objekt zurückgeben
 */
var parseDate = function(d, reset) {
    if ( d === null ) return null;
    let result;

    if ( d instanceof Date ) {
        result = moment(d);
    } else {
        result = moment(d, [
            'L',
            'DD.MM.YY',
            'DD.MM.YYYY',
            'YYYY-MM-DD',
        ]);
    }
    return reset ? resetTimeFields(result) : result;
};

/**
 * Now for the ugly hacks
 */
window.initExplorerIBE = function($) {

    let calendar;
    let peopleselect;
    let calendar_display;
    let people_display;

    widgetClasses["peopleselect"] = ReduxPeopleSelect;
    widgetClasses["calendar"] = ReduxMiniCalendar;
    widgetClasses["calendar-display"] = CalendarDisplay;

    let params = getQueryParameters();
    let input_ds   = $('input[name=datepicker-defaultstartin]').val();
    let input_dd   = $('input[name=datepicker-defaultdays]').val();
    let input_from = $('input[name=datepicker-from]').val();
    let input_to   = $('input[name=datepicker-to]').val();

    let start_date;
    let end_date;

    if ( params.from && params.to ) {
        let date_from = parseDate(params.from, true);
        let date_to   = parseDate(params.to, true);

        if ( date_from.isValid() && date_to.isValid() ) {
            console.log(`[IBE] Using from (${params.from}) and to (${params.to}) from parameters`);
            start_date = date_from;
            end_date   = date_to;
        } else {
            console.log(`[IBE] Warning: from (${params.from}) and to (${params.to}) parameters are invalid`);
        }

    } else if ( input_from && input_to ) {
        let date_from = parseDate(input_from, true);
        let date_to   = parseDate(input_to, true);

        if ( date_from.isValid() && date_to.isValid() ) {
            console.log(`[IBE] Using from (${input_from}) and to (${input_to}) from input fields`);
            start_date = date_from;
            end_date   = date_to;
        } else {
            console.log(`[IBE] Warning: from (${input_from}) and to (${input_to}) input fields are invalid`);
        }

    } else if ( params.defaultstartin && params.defaultdays ) {
        let defaultstartin = parseInt(params.defaultstartin, 10);
        let defaultdays = parseInt(params.defaultdays, 10);

        if ( defaultstartin > 0 && defaultdays > 0 ) {
            console.log(`[IBE] Using defaultstartin (${defaultstartin}) and defaultdays (${defaultdays}) from parameters`);
            start_date = resetTimeFields(moment()).add(defaultstartin, 'days')
            end_date   = resetTimeFields(moment()).add(defaultstartin + defaultdays, 'days')
        }

    } else if ( input_ds && input_dd ) {
        let defaultstartin = parseInt(input_ds, 10);
        let defaultdays = parseInt(input_dd, 10);

        if ( defaultstartin > 0 && defaultdays > 0 ) {
            console.log(`[IBE] Using defaultstartin (${defaultstartin}) and defaultdays (${defaultdays}) from input fields`);
            start_date = resetTimeFields(moment()).add(defaultstartin, 'days')
            end_date   = resetTimeFields(moment()).add(defaultstartin + defaultdays, 'days')
        }

    }

    if ( !start_date || !end_date || !start_date.isValid() || !end_date.isValid() ) {
        start_date = resetTimeFields(moment()).add(3, 'days');
        end_date   = resetTimeFields(moment()).add(6, 'days');
    }

    ibe.store.dispatch(setSelection(start_date._d, end_date._d));


    ibe.widget("calendar", "calendar", { count: 2 });
    ibe.widget("peopleselect", "peopleselect", {
        maxAdultsPerRoom: 3,
        maxChildrenPerRoom: 3,
    });

    ibe.widget("calendar-display", "datepicker-display", { format: "short" });
    ibe.widget("people-display", "peopleselect-display", { format: "shorter" });

    calendar = $('#calendar');
    peopleselect = $('#peopleselect');
    calendar_display = $('#datepicker-display');
    people_display = $('#peopleselect-display');

    /*
    people_display.off('click').on('click', function() {
        calendar.hide();
        peopleselect.slideToggle(200);
    });
    calendar_display.off('click').on('click', function() {
        peopleselect.hide();
        calendar.slideToggle(200);
    });
    */

    $(document).on('click', 'button.button.booking', function(e) {
        e.preventDefault();
        let state = ibe.store.getState();

        let params = {
            rooms: state.people['rooms'],

            erwachsene_1: state.people['rooms.1.adults'],
            erwachsene_2: state.people['rooms.2.adults'],
            erwachsene_3: state.people['rooms.3.adults'],

            kinder_1: state.people['rooms.1.children'],
            kind1_1: state.people['rooms.1.child1'],
            kind2_1: state.people['rooms.1.child2'],
            kind3_1: state.people['rooms.1.child3'],

            kinder_2: state.people['rooms.2.children'],
            kind1_2: state.people['rooms.2.child1'],
            kind2_2: state.people['rooms.2.child2'],
            kind3_2: state.people['rooms.2.child3'],

            kinder_3: state.people['rooms.3.children'],
            kind1_3: state.people['rooms.3.child1'],
            kind2_3: state.people['rooms.3.child2'],
            kind3_3: state.people['rooms.3.child3'],
        };

        if ( state.calendar.selectionStart && state.calendar.selectionEnd ) {
            params.from = moment(state.calendar.selectionStart).format("YYYY-MM-DD");
            params.to = moment(state.calendar.selectionEnd).format("YYYY-MM-DD");
        }

        location.href = ( window.Tramino.lang != "de" ? "/" + window.Tramino.lang : "" ) + '/booking/?' + $.param(params);
    });

    function updateCalendarWidth() {
        let width = $(window).width();
        ibe.store.dispatch({
            type: "CALENDAR_SET_COUNT",
            count: width > 767 ? 2 : 1,
        })
    }

    $(window).on('resize', updateCalendarWidth);
    updateCalendarWidth()

}



/** WEBPACK FOOTER **
 ** ./main.js
 **/